"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectView = void 0;
var _SourceProvider = require("../SourceProvider");
var _AccountSelectView = require("./AccountSelectView");
const AccountSelectView = exports.AccountSelectView = (0, _SourceProvider.SourceProvider)(_AccountSelectView.AccountSelectView);